/**
 * Web entry point for LaViola.it
 * Uses react-native-web's AppRegistry to mount the app.
 */

import { AppRegistry } from 'react-native';
import App from './App';

// Register the app
AppRegistry.registerComponent('LaViolaApp', () => App);

// Mount to DOM
AppRegistry.runApplication('LaViolaApp', {
  rootTag: document.getElementById('root'),
});
